import { Select } from "@cofano/cck";
import { SelectProps } from "@cofano/cck/Select/Select";
import { gql } from "__generated__/gql";
import { useApolloClient } from "@apollo/client";
import { Voyages_VoyageSelectQuery } from "__generated__/graphql";
import { ChildPropsFromPagination } from "types/commons";

type BaseOption = ChildPropsFromPagination<Voyages_VoyageSelectQuery, "voyages">;
export type VoyageSelectOption = Pick<BaseOption, "id" | "voyageNumber"> & Partial<Omit<BaseOption, "id" | "voyageNumber">>;

const VoyageSelect = <Multiple extends boolean = false,>({
	searchableShipId,
	includeExpired,
	...rest
}: {
	searchableShipId?: number,
	includeExpired?: boolean,
} & Omit<SelectProps<VoyageSelectOption, Multiple>, "fetchOptions" | "paginated">) => {

	const client = useApolloClient();

	const onFetchOptions = async (params: string, page: number) => {

		try  {
			const result = await client.query({
				query: query,
				variables: {
					search: {
						voyageNumbers: params ? [ params ] : undefined,
						ships: searchableShipId ? [ searchableShipId ] : undefined,
						includeExpiredVoyages: includeExpired,
					},
					pagination: {
						page: page - 1,
						size: 5,
					},
				},
			});

			return {
				options: result.data.voyages.content,
				totalResults: result.data.voyages.totalElements,
			};
		} catch (response) {
			return {
				options: [],
				totalResults: 0,
			};
		}
	};

	return (
		<Select
			{...rest}
			fetchOptions={onFetchOptions}
			getOptionLabel={(option) => option.voyageNumber}
			paginated
		/>
	);
};

const query = gql(`#graphql
	query voyages_voyageSelect($search: VoyageSearchObject!, $pagination: Pagination!) {
		voyages(search: $search, pagination: $pagination) {
			totalElements
			content {
				id
				voyageNumber
				from {
					id
					description
				}
				to {
					id
					description
				}
				calls {
					id
					pta
					ptd
					location {
						id
						type
						description
					}
				}
				creditor {
					id
					name
				}
				purchaseCharters {
					id
					charterNumber
					type
				}
			}
		}
	}
`);

export default VoyageSelect;
